import sdkProvider from "../../../../client/sdkProvider";
import { setLoyaltyTier } from ".";
import setIsBenefitAvailable from "./setIsBenefitAvailable";
import logger from "../../../../lib/logger";

const loadLoyaltyIsBenefitAvailable = loyaltyBenefitType => async dispatch => {
  try {
    const identitySdk = await sdkProvider("identity");
    const isAuthenticated = await identitySdk.customer.isAuthenticated();
    if (!isAuthenticated) {
      dispatch(setLoyaltyTier(null));

      return;
    }

    const loyaltySdk = await sdkProvider("loyalty");
    const customerTierId = await loyaltySdk.getCustomerTierId();
    if (customerTierId) {
      const benefitAvailableForTier = await loyaltySdk.isBenefitAvailableForTier(
        customerTierId,
        loyaltyBenefitType
      );
      dispatch(
        setIsBenefitAvailable(benefitAvailableForTier, loyaltyBenefitType)
      );
    } else {
      dispatch(setIsBenefitAvailable(false, loyaltyBenefitType));
    }
  } catch (error) {
    if (error.name !== "LoyaltyNotSupportedError") {
      error.message = `loadLoyaltyIsBenefitAvailable failed with error: ${error.message}`;
      logger.error(error);
    }
  }
};

export default loadLoyaltyIsBenefitAvailable;
